export const AppSettings = {
    "ShopifyApiKey": process.env.REACT_APP_SHOPIFY_API_KEY,
    "AuthRedirect": process.env.REACT_APP_AUTH_REDIRECT,
    "AppHost": process.env.REACT_APP_APP_HOST,
    "ApiHost": process.env.REACT_APP_API_HOST,
    "AppInsightsKey": process.env.REACT_APP_APPINSIGHTS_KEY
};